import { CustomReport } from "@/components/CustomReports/models/CustomReport";
import { TemplateSelection } from "@/components/TemplateManagement/models";


export class QueueCustomReportsArgs {

    // Flattened custom reports
    constructor(public readonly customReports: Array<CustomReport>,
        public readonly parentExecutionId?: string,
        public name?: string,
        public readonly templateSelection?: TemplateSelection | null
    ) {
        if (customReports == null) throw Error("calculations are required");
    }

}